import {
    DATIQ_DEFAULT_ARRAY,
    DATIQ_DEFAULT_EMPTY_LABEL,
    DATIQ_DEFAULT_ID,
} from './datiq-app-default-values';
import { IDatiqUnavPanel } from './datiq-unav-panel.interface';
import { IDatiqUnavItem } from './datiq-unav.interface';

export const emptyDatiqUnavPanel: IDatiqUnavPanel = {
    id: DATIQ_DEFAULT_ID('panel-'),
    items: DATIQ_DEFAULT_ARRAY as IDatiqUnavItem[],
    title: DATIQ_DEFAULT_EMPTY_LABEL,
};
